import { Component, OnInit } from '@angular/core';
import { DataEmpresaService } from "../../../modulo-comunes/servicios/data-empresa-servicios";

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {
  sitio: string;
  srcLogoSt: string;

  constructor(
    public dataEmpresaService: DataEmpresaService
  ) { }

  ngOnInit() {
    this.sitio = this.dataEmpresaService.sitioElegido;
    this.srcLogoSt= "assets/images/logo292x172.png";
  }

}
